import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SubSink } from 'subsink';
import { Observable } from 'rxjs';
import { HistoryService } from 'src/app/shared/service/history.service';
import { Session } from 'src/app/shared/models/session.model';
import { ServerDataSource } from 'ng2-smart-table';
import { HttpClient } from '@angular/common/http';
import { SmartTableService } from 'src/app/shared/service/smart-table.service';
import { DateFormatPipe } from 'src/app/shared/pipes/jdate.pipe';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sessions-shared',
  templateUrl: './sessions.component.html',
  styleUrls: ['./sessions.component.scss']
})
export class SessionsComponent implements OnInit, OnDestroy {
  @Input() set userId(userId: number | null) {
    this.source = new ServerDataSource(this.http, {
      endPoint: userId
        ? this.baseUrl + '/v1/admin/sessions/' + userId
        : this.baseUrl + '/v1/user/sessions?active=0',
      dataKey: 'data',
      totalKey: 'total_records',
      pagerPageKey: 'page',
      pagerLimitKey: 'limit',
      filterFieldKey: '#field#',
      sortDirKey: 'order_direction',
      sortFieldKey: 'order_by'
    });
    const filterArray = [{ field: 'deleted_at', search: null }];
    this.source.setFilter(filterArray, false, false);
    this.source.refresh();
  }

  sub = new SubSink();
  sessionsObs!: Observable<Session[]>;
  deleting: any;
  settings = {
    actions: {
      columnTitle: 'ارسال اعلان / ویرایش ',
      add: false,
      edit: false,
      delete: false
    },
    sort: false,
    hideSubHeader: true,
    columns: {
      ip: {
        title: 'آدرس IP',
        type: 'html',
        valuePrepareFunction: (value: any) => {
          if (value !== null) {
            return `<span class="en-num">${value}</span>`;
          }
          return '-';
        },
        sort: false,
        filter: false
      },
      platform: {
        title: 'پلتفرم',
        sort: false,
        filter: false,
        valuePrepareFunction: (value: any) => {
          if (value !== null) {
            return value;
          }
          return '-';
        }
      },

      created_at: {
        title: 'تاریخ ورود',
        valuePrepareFunction: (value: any) => {
          if (value) {
            return this.dateFormatPipe.transform(value, 'jDD jMMMM - HH:mm');
          }
          return '-';
        },
        sort: false,
        filter: false
      },
      deleted_at: {
        title: 'تاریخ خروج',
        valuePrepareFunction: (value: any) => {
          if (value) {
            return this.dateFormatPipe.transform(value, 'jDD jMMMM - HH:mm');
          }
          return '-';
        },
        sort: false,
        filter: false
      },
      location: {
        title: 'موقعیت مکانی',
        sort: false,
        filter: false,
        valuePrepareFunction: (value: any) => {
          if (value !== null && value.country !== null && value.city !== null) {
            return JSON.stringify(value);
          }
          return '-';
        }
      }
    },
    attr: {
      class: 'smart-table-responsive text-center no-wrap table-bordered'
    },
    pager: {
      display: true,
      perPage: 15
    },
    noDataMessage: 'ورودی تاکنون ثبت نشده است.'
  };
  source!: ServerDataSource;
  tableLoading = true;
  baseUrl = environment.baseUrl;

  constructor(
    private history: HistoryService,
    private dateFormatPipe: DateFormatPipe,
    private http: HttpClient,
    private smartTableService: SmartTableService
  ) {}

  ngOnInit(): void {
    this.sessionsObs = this.history.getSessions();
    this.sub.sink = this.source?.onChanged()?.subscribe(() => {
      this.tableLoading = false;
      this.smartTableService.makeTableResponsive();
    });
    this.sub.sink = this.smartTableService?.loadingEvent?.subscribe(() => {
      this.tableLoading = true;
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  changeRecordPerPageLimit(limit: number): void {
    this.source.setPaging(1, limit, true);
    this.tableLoading = true;
  }

  deleteSession(session: Session): void {
    this.deleting = true;
    this.history.deleteSession(session.id).subscribe((res) => {
      this.deleting = false;
      this.sessionsObs = this.history.getSessions();
    });
  }

  actions($event: any): void {
    if ($event.action === 'notification') {
      // this.router.navigateByUrl('/dashboard/notification', {state: $event.data});
    } else {
      // this.router.navigateByUrl(`/dashboard/user/${$event.data.id}`);
    }
  }
}
